import React, { useState } from 'react';
import { Button } from '../components/Button';
import { SparklesIcon, CheckCircleIcon, ShieldCheckIcon, ClockIcon, AwardIcon, PhoneIcon, MessageSquareIcon, CalendarIcon, HelpCircleIcon, BellIcon, PlayIcon, StarIcon, QuoteIcon, PhoneForwardedIcon, MessageCircleIcon, CalendarCheckIcon, ZapIcon, WorkflowIcon, DatabaseIcon, BrainCircuitIcon, CheckIcon, ChevronDownIcon } from 'lucide-react';
function GradientHeroLight() {
  return <section className="w-full min-h-screen bg-[#FAFAFA] relative overflow-hidden flex items-center" data-id="element-1094">
      {/* Animated Gradient Mesh Background */}
      <div className="absolute inset-0" data-id="element-1095">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#F1B530] rounded-full mix-blend-multiply filter blur-[128px] opacity-10 animate-blob" data-id="element-1096"></div>
        <div className="absolute top-0 right-1/4 w-96 h-96 bg-[#D09F2B] rounded-full mix-blend-multiply filter blur-[128px] opacity-10 animate-blob animation-delay-2000" data-id="element-1097"></div>
        <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-[#A78942] rounded-full mix-blend-multiply filter blur-[128px] opacity-10 animate-blob animation-delay-4000" data-id="element-1098"></div>
      </div>

      <div className="max-w-7xl mx-auto px-8 md:px-12 py-20 relative z-10" data-id="element-1099">
        <div className="text-center mb-16" data-id="element-1100">
          <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-md border border-[#F1B530]/30 rounded-full px-6 py-3 mb-8 shadow-sm" data-id="element-1101">
            <SparklesIcon className="w-4 h-4 text-[#F1B530]" data-id="element-1102" />
            <span className="font-['Poppins'] text-sm text-[#1A1A1A] font-medium" data-id="element-1103">
              AI-Powered Answering Service
            </span>
          </div>

          <h1 className="font-['Poppins'] font-bold text-5xl md:text-7xl lg:text-8xl text-[#1A1A1A] mb-8 leading-tight" data-id="element-1104">
            <span className="bg-gradient-to-r from-[#1A1A1A] via-[#F1B530] to-[#1A1A1A] bg-clip-text text-transparent animate-gradient" data-id="element-1105">
              Never Miss
            </span>
            <br data-id="element-1106" />
            Another Call
          </h1>

          <p className="font-['Inter'] text-xl md:text-2xl text-[#6B6B6B] max-w-3xl mx-auto mb-12 leading-relaxed font-light" data-id="element-1107">
            24/7 AI receptionist that answers instantly, captures perfectly, and
            integrates seamlessly with your business.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16" data-id="element-1108">
            <Button size="lg" data-id="element-1109">Start Free Trial</Button>
            <Button variant="secondary" size="lg" theme="light" data-id="element-1110">
              Watch Demo
            </Button>
          </div>
        </div>

        {/* Floating Demo Card */}
        <div className="max-w-5xl mx-auto" data-id="element-1111">
          <div className="bg-white/80 backdrop-blur-xl border border-[#E5E5E5] rounded-3xl p-8 shadow-2xl" data-id="element-1112">
            <div className="aspect-video bg-[#F5F5F5] rounded-2xl flex items-center justify-center relative overflow-hidden" data-id="element-1113">
              <img src="https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200&q=80" alt="Dashboard preview" className="w-full h-full object-cover opacity-80" data-id="element-1114" />
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-1115">
                <div className="w-20 h-20 bg-[#F1B530] rounded-full flex items-center justify-center cursor-pointer hover:scale-110 transition-transform duration-300 shadow-lg" data-id="element-1116">
                  <PlayIcon className="w-8 h-8 text-white fill-white ml-1" data-id="element-1117" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style data-id="element-1118">{`
        @keyframes blob {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
        @keyframes gradient {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        .animate-gradient {
          background-size: 200% auto;
          animation: gradient 3s linear infinite;
        }
      `}</style>
    </section>;
}
function TrustBadgesLight() {
  const badges = [{
    icon: CheckCircleIcon,
    label: '99.9% Uptime',
    value: 'Guaranteed'
  }, {
    icon: ShieldCheckIcon,
    label: 'Enterprise Security',
    value: 'SOC 2 Certified'
  }, {
    icon: ClockIcon,
    label: '24/7 Support',
    value: 'Always Available'
  }, {
    icon: AwardIcon,
    label: '10,000+ Calls',
    value: 'Handled Daily'
  }];
  return <section className="w-full bg-white py-16 border-y border-[#E5E5E5]" data-id="element-1119">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-1120">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-1121">
          {badges.map((badge, index) => {
          const Icon = badge.icon;
          return <div key={index} className="text-center" data-id="element-1122">
                <div className="w-16 h-16 bg-[#F1B530]/10 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-[#F1B530]/20" data-id="element-1123">
                  <Icon className="w-8 h-8 text-[#F1B530]" data-id="element-1124" />
                </div>
                <div className="font-['Poppins'] text-2xl font-bold text-[#1A1A1A] mb-1" data-id="element-1125">
                  {badge.label}
                </div>
                <div className="font-['Inter'] text-sm text-[#6B6B6B]" data-id="element-1126">
                  {badge.value}
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}
function BoltValuePropositionLight() {
  const benefits = [{
    icon: ClockIcon,
    title: '24/7 Instant Call Answering',
    description: 'Never miss a call again with round-the-clock AI coverage that picks up instantly'
  }, {
    icon: MessageSquareIcon,
    title: 'Customised Company Greeting',
    description: 'Fully branded experience that sounds like your business, not a generic service'
  }, {
    icon: PhoneIcon,
    title: 'Accurate Capture',
    description: 'Precise name, number, and message recording with intelligent transcription'
  }, {
    icon: BellIcon,
    title: 'Real-Time Call Summaries',
    description: 'Instant notifications with complete call context delivered immediately'
  }, {
    icon: HelpCircleIcon,
    title: 'FAQ Handling',
    description: 'Answer common questions with fenced, brand-safe responses automatically'
  }, {
    icon: CalendarIcon,
    title: 'Appointment Booking',
    description: 'Seamless calendar integration for automated scheduling and confirmations'
  }];
  return <section className="w-full bg-[#FAFAFA] py-28 md:py-36 relative overflow-hidden" data-id="element-1127">
      {/* Gradient accents */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#F1B530] opacity-5 rounded-full blur-3xl" data-id="element-1128"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D09F2B] opacity-5 rounded-full blur-3xl" data-id="element-1129"></div>

      <div className="max-w-7xl mx-auto px-8 md:px-12 relative z-10" data-id="element-1130">
        <div className="text-center mb-20" data-id="element-1131">
          <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl lg:text-6xl mb-6 tracking-tight" data-id="element-1132">
            <span className="bg-gradient-to-r from-[#1A1A1A] via-[#F1B530] to-[#1A1A1A] bg-clip-text text-transparent" data-id="element-1133">
              Why Choose Our AI Answering Service?
            </span>
          </h2>
          <p className="font-['Inter'] font-light text-xl md:text-2xl text-[#6B6B6B]" data-id="element-1134">
            Your Always-On Receptionist, without the overheads
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1135">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <div key={index} className="group relative bg-gradient-to-br from-white to-[#FAFAFA] rounded-2xl p-8 border border-[#E5E5E5] hover:border-[#F1B530]/50 transition-all duration-500 hover:-translate-y-2 shadow-sm hover:shadow-lg" data-id="element-1136">
                {/* Gradient glow on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-[#F1B530]/0 to-[#F1B530]/0 group-hover:from-[#F1B530]/5 group-hover:to-[#D09F2B]/5 rounded-2xl transition-all duration-500" data-id="element-1137"></div>

                <div className="relative" data-id="element-1138">
                  {/* Icon with gradient background */}
                  <div className="w-16 h-16 bg-gradient-to-br from-[#F1B530] to-[#D09F2B] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-md" data-id="element-1139">
                    <Icon className="w-8 h-8 text-white" data-id="element-1140" />
                  </div>

                  <h3 className="font-['Inter'] font-semibold text-xl text-[#1A1A1A] mb-4 group-hover:text-[#F1B530] transition-colors duration-300" data-id="element-1141">
                    {benefit.title}
                  </h3>

                  <p className="font-['Inter'] text-[#6B6B6B] leading-relaxed font-light" data-id="element-1142">
                    {benefit.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}
function BoltFeatureShowcaseLight() {
  return <section className="w-full bg-white py-28 md:py-36 relative overflow-hidden" data-id="element-1143">
      {/* Gradient accents */}
      <div className="absolute top-20 right-20 w-64 h-64 bg-[#F1B530] opacity-5 rounded-full blur-3xl" data-id="element-1144"></div>
      <div className="absolute bottom-40 left-20 w-80 h-80 bg-[#D09F2B] opacity-5 rounded-full blur-3xl" data-id="element-1145"></div>

      <div className="max-w-7xl mx-auto px-8 md:px-12 relative z-10" data-id="element-1146">
        {/* Feature 1 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-32" data-id="element-1147">
          <div className="relative group" data-id="element-1148">
            <div className="absolute inset-0 bg-gradient-to-r from-[#F1B530] to-[#D09F2B] rounded-3xl opacity-10 blur-xl group-hover:opacity-20 transition-opacity duration-500" data-id="element-1149"></div>
            <div className="relative aspect-[4/3] rounded-3xl overflow-hidden border border-[#E5E5E5] shadow-lg" data-id="element-1150">
              <img src="https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200&q=80" alt="Real-time dashboard" className="w-full h-full object-cover" data-id="element-1151" />
            </div>
            <div className="absolute -bottom-8 -right-8 bg-gradient-to-br from-[#F1B530] to-[#D09F2B] rounded-2xl p-6 shadow-2xl" data-id="element-1152">
              <div className="font-['Poppins'] text-4xl font-bold text-white mb-1" data-id="element-1153">
                100%
              </div>
              <div className="font-['Inter'] text-sm text-white font-semibold" data-id="element-1154">
                Capture Rate
              </div>
            </div>
          </div>

          <div data-id="element-1155">
            <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#1A1A1A] mb-6 bg-gradient-to-r from-[#1A1A1A] to-[#F1B530] bg-clip-text text-transparent" data-id="element-1156">
              Real-Time Dashboard & Analytics
            </h2>
            <p className="font-['Inter'] text-lg text-[#6B6B6B] mb-8 leading-relaxed font-light" data-id="element-1157">
              Monitor every call in real-time with comprehensive analytics.
              Track call volume, response times, customer satisfaction, and
              conversion rates all in one intuitive dashboard.
            </p>
            <ul className="space-y-4 mb-8" data-id="element-1158">
              <li className="flex items-start" data-id="element-1159">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1160">•</span>
                <span className="font-['Inter'] text-[#1A1A1A] font-light" data-id="element-1161">
                  Live call monitoring and notifications
                </span>
              </li>
              <li className="flex items-start" data-id="element-1162">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1163">•</span>
                <span className="font-['Inter'] text-[#1A1A1A] font-light" data-id="element-1164">
                  Detailed call transcripts and recordings
                </span>
              </li>
              <li className="flex items-start" data-id="element-1165">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1166">•</span>
                <span className="font-['Inter'] text-[#1A1A1A] font-light" data-id="element-1167">
                  Performance metrics and insights
                </span>
              </li>
            </ul>
            <Button data-id="element-1168">Explore Dashboard</Button>
          </div>
        </div>

        {/* Feature 2 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-32" data-id="element-1169">
          <div className="lg:order-2 relative group" data-id="element-1170">
            <div className="absolute inset-0 bg-gradient-to-r from-[#D09F2B] to-[#F1B530] rounded-3xl opacity-10 blur-xl group-hover:opacity-20 transition-opacity duration-500" data-id="element-1171"></div>
            <div className="relative aspect-[4/3] rounded-3xl overflow-hidden border border-[#E5E5E5] shadow-lg" data-id="element-1172">
              <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200&q=80" alt="Integrations" className="w-full h-full object-cover" data-id="element-1173" />
            </div>
            <div className="absolute -bottom-8 -left-8 bg-white border-2 border-[#F1B530] rounded-2xl p-6 shadow-2xl" data-id="element-1174">
              <div className="font-['Poppins'] text-4xl font-bold text-[#F1B530] mb-1" data-id="element-1175">
                50+
              </div>
              <div className="font-['Inter'] text-sm text-[#1A1A1A] font-semibold" data-id="element-1176">
                Integrations
              </div>
            </div>
          </div>

          <div className="lg:order-1" data-id="element-1177">
            <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#1A1A1A] mb-6 bg-gradient-to-r from-[#1A1A1A] to-[#F1B530] bg-clip-text text-transparent" data-id="element-1178">
              Seamless CRM & Tool Integration
            </h2>
            <p className="font-['Inter'] text-lg text-[#6B6B6B] mb-8 leading-relaxed font-light" data-id="element-1179">
              Connect with your existing tools effortlessly. Our AI integrates
              with popular CRMs, calendars, and business tools to keep your
              workflow smooth and data synchronized.
            </p>
            <ul className="space-y-4 mb-8" data-id="element-1180">
              <li className="flex items-start" data-id="element-1181">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1182">•</span>
                <span className="font-['Inter'] text-[#1A1A1A] font-light" data-id="element-1183">
                  Salesforce, HubSpot, Zoho CRM
                </span>
              </li>
              <li className="flex items-start" data-id="element-1184">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1185">•</span>
                <span className="font-['Inter'] text-[#1A1A1A] font-light" data-id="element-1186">
                  Google Calendar, Outlook, Calendly
                </span>
              </li>
              <li className="flex items-start" data-id="element-1187">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1188">•</span>
                <span className="font-['Inter'] text-[#1A1A1A] font-light" data-id="element-1189">
                  Slack, Teams, Zapier, and more
                </span>
              </li>
            </ul>
            <Button data-id="element-1190">View All Integrations</Button>
          </div>
        </div>

        {/* Feature 3 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-1191">
          <div className="relative group" data-id="element-1192">
            <div className="absolute inset-0 bg-gradient-to-r from-[#F1B530] to-[#D09F2B] rounded-3xl opacity-10 blur-xl group-hover:opacity-20 transition-opacity duration-500" data-id="element-1193"></div>
            <div className="relative aspect-[4/3] rounded-3xl overflow-hidden border border-[#E5E5E5] shadow-lg" data-id="element-1194">
              <img src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&q=80" alt="AI training" className="w-full h-full object-cover" data-id="element-1195" />
            </div>
            <div className="absolute -bottom-8 -right-8 bg-white border-2 border-[#F1B530] rounded-2xl p-6 shadow-2xl" data-id="element-1196">
              <div className="font-['Poppins'] text-4xl font-bold text-[#F1B530] mb-1" data-id="element-1197">
                &lt;5min
              </div>
              <div className="font-['Inter'] text-sm text-[#1A1A1A] font-semibold" data-id="element-1198">
                Setup Time
              </div>
            </div>
          </div>

          <div data-id="element-1199">
            <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#1A1A1A] mb-6 bg-gradient-to-r from-[#1A1A1A] to-[#F1B530] bg-clip-text text-transparent" data-id="element-1200">
              Custom AI Training for Your Business
            </h2>
            <p className="font-['Inter'] text-lg text-[#6B6B6B] mb-8 leading-relaxed font-light" data-id="element-1201">
              Train your AI receptionist with your business knowledge, FAQs, and
              specific protocols. The more you customize, the more natural and
              helpful your AI becomes.
            </p>
            <ul className="space-y-4 mb-8" data-id="element-1202">
              <li className="flex items-start" data-id="element-1203">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1204">•</span>
                <span className="font-['Inter'] text-[#1A1A1A] font-light" data-id="element-1205">
                  Upload FAQs and knowledge base
                </span>
              </li>
              <li className="flex items-start" data-id="element-1206">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1207">•</span>
                <span className="font-['Inter'] text-[#1A1A1A] font-light" data-id="element-1208">
                  Define custom call routing rules
                </span>
              </li>
              <li className="flex items-start" data-id="element-1209">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1210">•</span>
                <span className="font-['Inter'] text-[#1A1A1A] font-light" data-id="element-1211">
                  Set brand voice and tone guidelines
                </span>
              </li>
            </ul>
            <Button data-id="element-1212">Start Customizing</Button>
          </div>
        </div>
      </div>
    </section>;
}
function BoltIndustryBenefitsLight() {
  const industries = [{
    name: 'Healthcare',
    benefits: ['HIPAA compliant', 'Appointment scheduling', 'Emergency routing', 'Patient messaging']
  }, {
    name: 'Legal',
    benefits: ['Client intake', 'Confidential handling', 'Urgent call screening', 'Case management']
  }, {
    name: 'Real Estate',
    benefits: ['Property inquiries', 'Viewing bookings', 'Lead capture', 'Tenant support']
  }, {
    name: 'Trade Services',
    benefits: ['Job booking', 'Emergency calls', 'Quote requests', 'Service scheduling']
  }, {
    name: 'Retail',
    benefits: ['Order taking', 'Store inquiries', 'Stock checks', 'Customer support']
  }, {
    name: 'Professional Services',
    benefits: ['Client screening', 'Appointment booking', 'Message handling', 'Consultation scheduling']
  }];
  return <section className="w-full bg-[#FAFAFA] py-28 relative overflow-hidden" data-id="element-1213">
      {/* Gradient accents */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#F1B530] opacity-5 rounded-full blur-3xl" data-id="element-1214"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D09F2B] opacity-5 rounded-full blur-3xl" data-id="element-1215"></div>

      <div className="max-w-7xl mx-auto px-8 md:px-12 relative z-10" data-id="element-1216">
        <div className="text-center mb-16" data-id="element-1217">
          <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl mb-6" data-id="element-1218">
            <span className="bg-gradient-to-r from-[#1A1A1A] via-[#F1B530] to-[#1A1A1A] bg-clip-text text-transparent" data-id="element-1219">
              Trusted Across Industries
            </span>
          </h2>
          <p className="font-['Inter'] text-xl text-[#6B6B6B] font-light" data-id="element-1220">
            Tailored solutions for every business type
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1221">
          {industries.map((industry, index) => <div key={index} className="group relative bg-gradient-to-br from-white to-[#FAFAFA] rounded-2xl p-8 border border-[#E5E5E5] hover:border-[#F1B530]/50 transition-all duration-500 shadow-sm hover:shadow-md" data-id="element-1222">
              <div className="absolute inset-0 bg-gradient-to-br from-[#F1B530]/0 to-[#F1B530]/0 group-hover:from-[#F1B530]/5 group-hover:to-[#D09F2B]/5 rounded-2xl transition-all duration-500" data-id="element-1223"></div>

              <div className="relative" data-id="element-1224">
                <h3 className="font-['Poppins'] font-bold text-2xl text-[#1A1A1A] mb-6 group-hover:text-[#F1B530] transition-colors duration-300" data-id="element-1225">
                  {industry.name}
                </h3>
                <ul className="space-y-3" data-id="element-1226">
                  {industry.benefits.map((benefit, idx) => <li key={idx} className="font-['Inter'] text-[#6B6B6B] flex items-start" data-id="element-1227">
                      <span className="text-[#F1B530] mr-2" data-id="element-1228">•</span>
                      {benefit}
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function BoltPricingPlansLight() {
  const plans = [{
    name: 'Scout 25',
    price: 'AUD $65',
    calls: '25 calls/month',
    minutes: '125',
    target: 'Perfect for solo operators testing the waters',
    inclusions: ['Instant call pickup', 'Customised company greeting', 'Name, number & message capture', 'Real-time call summaries via SMS/email', 'Call recordings & transcripts', 'Dashboard analytics', 'Excess: $2.60/call or $0.52/min'],
    ctaText: 'Start 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'Forager 50',
    price: 'AUD $115',
    calls: '50 calls/month',
    minutes: '250',
    target: 'Small teams with steady enquiry flow',
    inclusions: ['Everything in Scout 25', 'Priority support', 'Extended call handling', 'Multi-user dashboard access', 'Custom call routing rules', 'Excess: $2.30/call or $0.46/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording',
    isPopular: true
  }, {
    name: 'Drift 75',
    price: 'AUD $165',
    calls: '75 calls/month',
    minutes: '375',
    target: 'Growing teams with rising call peaks',
    inclusions: ['Everything in Forager 50', 'Advanced analytics', 'Team collaboration tools', 'Custom integrations', 'Dedicated account manager', 'Excess: $2.20/call or $0.44/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'Surge 150',
    price: 'AUD $325',
    calls: '150 calls/month',
    minutes: '750',
    target: 'High-tempo operations with regular spikes',
    inclusions: ['Everything in Drift 75', 'Priority call routing', 'Advanced workflow automation', 'Custom reporting', 'API access', 'Excess: $2.17/call or $0.43/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'Swarm 300',
    price: 'AUD $645',
    calls: '300 calls/month',
    minutes: '1,500',
    target: 'Heavy daily call activity teams',
    inclusions: ['Everything in Surge 150', 'Enterprise-grade security', 'Custom AI training', 'White-label options', 'SLA guarantees', 'Excess: $2.15/call or $0.43/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'Colony 500',
    price: 'AUD $955',
    calls: '500 calls/month',
    minutes: '2,250',
    target: 'Enterprise-level high-volume operations',
    inclusions: ['Everything in Swarm 300', 'Dedicated infrastructure', 'Custom AI models', 'Advanced compliance features', '24/7 premium support', 'Excess: $1.91/call or $0.42/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'AI Automation Customisation',
    target: 'For businesses requiring advanced automation and integrations beyond standard plans',
    inclusions: ['Custom call volumes', 'Bespoke AI training', 'Enterprise integrations', 'Advanced workflow automation', 'Dedicated success team', 'Custom SLAs'],
    ctaText: 'Contact Sales',
    isCustom: true
  }];
  return <section className="w-full bg-[#FAFAFA] py-28 md:py-36 relative overflow-hidden" data-id="element-1229">
      {/* Gradient accents */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#F1B530] opacity-5 rounded-full blur-3xl" data-id="element-1230"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D09F2B] opacity-5 rounded-full blur-3xl" data-id="element-1231"></div>

      <div className="max-w-7xl mx-auto px-8 md:px-12 relative z-10" data-id="element-1232">
        <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl text-center mb-20 tracking-tight" data-id="element-1233">
          <span className="bg-gradient-to-r from-[#1A1A1A] via-[#F1B530] to-[#1A1A1A] bg-clip-text text-transparent" data-id="element-1234">
            Plans
          </span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-1235">
          {plans.slice(0, 6).map((plan, index) => <div key={index} className={`bg-white rounded-2xl p-10 border transition-all duration-300 hover:-translate-y-1 relative flex flex-col h-full shadow-sm hover:shadow-lg ${plan.isPopular ? 'border-[#F1B530] shadow-[0_0_40px_rgba(241,181,48,0.15)]' : 'border-[#E5E5E5] hover:border-[#F1B530]/50'}`} data-id="element-1236">
              {plan.isPopular && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#F1B530] text-white px-6 py-2 rounded-full font-['Inter'] font-semibold text-sm" data-id="element-1237">
                  Most Popular
                </div>}

              <div className="mb-8" data-id="element-1238">
                <h3 className="font-['Poppins'] font-bold text-2xl text-[#1A1A1A] mb-3" data-id="element-1239">
                  {plan.name}
                </h3>
                {!plan.isCustom ? <>
                    <div className="mb-3" data-id="element-1240">
                      <span className="font-['Poppins'] font-bold text-5xl text-[#1A1A1A]" data-id="element-1241">
                        {plan.price}
                      </span>
                      <span className="text-[#6B6B6B] font-['Inter'] ml-2 text-sm" data-id="element-1242">
                        plus GST/month
                      </span>
                    </div>
                    <p className="text-[#6B6B6B] font-['Inter'] text-sm mb-2 font-light" data-id="element-1243">
                      Up to {plan.calls} • {plan.minutes} free minutes
                    </p>
                  </> : <div className="mb-3" data-id="element-1244">
                    <span className="font-['Poppins'] font-bold text-4xl text-[#1A1A1A]" data-id="element-1245">
                      Custom Pricing
                    </span>
                  </div>}
                <p className="text-[#6B6B6B] font-['Inter'] text-sm italic font-light" data-id="element-1246">
                  {plan.target}
                </p>
              </div>

              <div className="mb-10 flex-grow" data-id="element-1247">
                <ul className="space-y-4" data-id="element-1248">
                  {plan.inclusions.map((inclusion, idx) => <li key={idx} className="flex items-start" data-id="element-1249">
                      <CheckIcon className="w-5 h-5 text-[#F1B530] mr-3 flex-shrink-0 mt-0.5" data-id="element-1250" />
                      <span className="font-['Inter'] text-[#1A1A1A] text-sm leading-relaxed font-light" data-id="element-1251">
                        {inclusion}
                      </span>
                    </li>)}
                </ul>
              </div>

              <div className="mt-auto" data-id="element-1252">
                <Button className="w-full" size="lg" data-id="element-1253">
                  {plan.ctaText}
                </Button>

                {plan.ctaLink && <a href="#" className="block text-center mt-5 text-[#6B6B6B] font-['Inter'] text-sm hover:text-[#F1B530] transition-colors duration-300" data-id="element-1254">
                    {plan.ctaLink}
                  </a>}
              </div>
            </div>)}
        </div>

        <div className="max-w-2xl mx-auto" data-id="element-1255">
          <div className="bg-white rounded-2xl p-10 border border-[#E5E5E5] hover:border-[#F1B530]/50 transition-all duration-300 hover:-translate-y-1 flex flex-col h-full shadow-sm hover:shadow-lg" data-id="element-1256">
            <div className="mb-8" data-id="element-1257">
              <h3 className="font-['Poppins'] font-bold text-2xl text-[#1A1A1A] mb-3" data-id="element-1258">
                {plans[6].name}
              </h3>
              <div className="mb-3" data-id="element-1259">
                <span className="font-['Poppins'] font-bold text-4xl text-[#1A1A1A]" data-id="element-1260">
                  Custom Pricing
                </span>
              </div>
              <p className="text-[#6B6B6B] font-['Inter'] text-sm italic font-light" data-id="element-1261">
                {plans[6].target}
              </p>
            </div>

            <div className="mb-10 flex-grow" data-id="element-1262">
              <ul className="space-y-4" data-id="element-1263">
                {plans[6].inclusions.map((inclusion, idx) => <li key={idx} className="flex items-start" data-id="element-1264">
                    <CheckIcon className="w-5 h-5 text-[#F1B530] mr-3 flex-shrink-0 mt-0.5" data-id="element-1265" />
                    <span className="font-['Inter'] text-[#1A1A1A] text-sm leading-relaxed font-light" data-id="element-1266">
                      {inclusion}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="mt-auto" data-id="element-1267">
              <Button className="w-full" size="lg" data-id="element-1268">
                {plans[6].ctaText}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function BoltTestimonialsLight() {
  const testimonials = [{
    quote: "This AI answering service has transformed how we handle customer calls. We've seen a 40% increase in captured leads since implementing it.",
    author: 'Sarah Mitchell',
    role: 'CEO, TechStart Solutions',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80',
    rating: 5
  }, {
    quote: 'The 24/7 coverage means we never miss an opportunity. Our customers love the instant response, and so do we.',
    author: 'James Chen',
    role: 'Operations Director, GrowthCo',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80',
    rating: 5
  }, {
    quote: "Setup was incredibly easy, and the AI sounds so natural. It's like having a professional receptionist without the overhead costs.",
    author: 'Emma Thompson',
    role: 'Founder, Bright Ideas Agency',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80',
    rating: 5
  }];
  return <section className="w-full bg-white py-28 md:py-36 relative overflow-hidden" data-id="element-1269">
      {/* Gradient accents */}
      <div className="absolute top-20 left-20 w-64 h-64 bg-[#F1B530] opacity-5 rounded-full blur-3xl" data-id="element-1270"></div>
      <div className="absolute bottom-40 right-20 w-80 h-80 bg-[#D09F2B] opacity-5 rounded-full blur-3xl" data-id="element-1271"></div>

      <div className="max-w-7xl mx-auto px-8 md:px-12 relative z-10" data-id="element-1272">
        <div className="text-center mb-20" data-id="element-1273">
          <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl mb-6" data-id="element-1274">
            <span className="bg-gradient-to-r from-[#1A1A1A] via-[#F1B530] to-[#1A1A1A] bg-clip-text text-transparent" data-id="element-1275">
              Trusted by Growing Businesses
            </span>
          </h2>
          <p className="font-['Inter'] text-xl text-[#6B6B6B] font-light" data-id="element-1276">
            See what our customers have to say
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1277">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white/80 backdrop-blur-sm border border-[#E5E5E5] rounded-2xl p-8 hover:border-[#F1B530]/30 transition-all duration-300 hover:-translate-y-1 shadow-sm hover:shadow-md" data-id="element-1278">
              <div className="flex gap-1 mb-6" data-id="element-1279">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#F1B530] fill-current" data-id="element-1280" />)}
              </div>

              <QuoteIcon className="w-10 h-10 text-[#F1B530]/20 mb-4" data-id="element-1281" />

              <p className="font-['Inter'] text-[#1A1A1A] mb-8 leading-relaxed font-light" data-id="element-1282">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4" data-id="element-1283">
                <img src={testimonial.image} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover border-2 border-[#F1B530]/20" data-id="element-1284" />
                <div data-id="element-1285">
                  <div className="font-['Inter'] font-semibold text-[#1A1A1A]" data-id="element-1286">
                    {testimonial.author}
                  </div>
                  <div className="font-['Inter'] text-sm text-[#6B6B6B]" data-id="element-1287">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function BoltAddOnsLight() {
  const addOns = [{
    icon: PhoneForwardedIcon,
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80',
    name: 'Live Transfer',
    price: 'AUD $99',
    setup: 'one-time setup',
    features: ['Instant Escalation for Time Sensitive Opportunities', 'Transfers With Full Caller Context', 'Smart Routing Based on Your Real Business Rules']
  }, {
    icon: MessageCircleIcon,
    image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&q=80',
    name: 'FAQ Handling',
    price: 'AUD $299',
    setup: 'one-time fee',
    features: ['Turn AI agent into trained front-line knowledge assistant', 'Fenced responses using only approved information', 'Clear brand-safe responses', 'Faster resolution & reduced message volume']
  }, {
    icon: CalendarCheckIcon,
    image: 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=800&q=80',
    name: 'Appointment Booking',
    price: 'AUD $399',
    setup: 'one-time setup',
    features: ['Real-time calendar syncing (Google, Outlook, etc.)', 'Automated booking and confirmation', 'Custom booking rules', 'Caller notifications and internal alerts']
  }];
  return <section className="w-full bg-[#FAFAFA] py-28 md:py-36 relative overflow-hidden" data-id="element-1288">
      {/* Gradient accents */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#F1B530] opacity-5 rounded-full blur-3xl" data-id="element-1289"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D09F2B] opacity-5 rounded-full blur-3xl" data-id="element-1290"></div>

      <div className="max-w-7xl mx-auto px-8 md:px-12 relative z-10" data-id="element-1291">
        <div className="text-center mb-20" data-id="element-1292">
          <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl mb-6 tracking-tight" data-id="element-1293">
            <span className="bg-gradient-to-r from-[#1A1A1A] via-[#F1B530] to-[#1A1A1A] bg-clip-text text-transparent" data-id="element-1294">
              Universal Add-Ons
            </span>
          </h2>
          <p className="font-['Inter'] text-lg text-[#6B6B6B] max-w-3xl mx-auto font-light" data-id="element-1295">
            Available for all plans to extend your AI answering service
            capabilities
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1296">
          {addOns.map((addOn, index) => {
          const Icon = addOn.icon;
          return <div key={index} className="bg-white rounded-2xl overflow-hidden border border-[#E5E5E5] hover:border-[#F1B530]/50 transition-all duration-300 hover:-translate-y-1 shadow-sm hover:shadow-md" data-id="element-1297">
                <div className="relative h-48 overflow-hidden" data-id="element-1298">
                  <img src={addOn.image} alt={addOn.name} className="w-full h-full object-cover opacity-80" data-id="element-1299" />
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent to-white" data-id="element-1300"></div>
                  <div className="absolute bottom-4 left-4 w-14 h-14 bg-gradient-to-br from-[#F1B530] to-[#D09F2B] backdrop-blur-sm rounded-xl flex items-center justify-center shadow-md" data-id="element-1301">
                    <Icon className="w-7 h-7 text-white" data-id="element-1302" />
                  </div>
                </div>

                <div className="p-10" data-id="element-1303">
                  <h3 className="font-['Poppins'] font-bold text-2xl text-[#1A1A1A] mb-3" data-id="element-1304">
                    {addOn.name}
                  </h3>

                  <div className="mb-8" data-id="element-1305">
                    <span className="font-['Poppins'] font-semibold text-2xl text-[#F1B530]" data-id="element-1306">
                      {addOn.price}
                    </span>
                    <span className="text-[#6B6B6B] font-['Inter'] text-sm ml-2" data-id="element-1307">
                      {addOn.setup}
                    </span>
                  </div>

                  <ul className="space-y-4" data-id="element-1308">
                    {addOn.features.map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-1309">
                        <span className="text-[#F1B530] mr-3 flex-shrink-0 text-lg" data-id="element-1310">
                          •
                        </span>
                        <span className="font-['Inter'] text-[#1A1A1A] text-sm leading-relaxed font-light" data-id="element-1311">
                          {feature}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}
function BoltAdvancedAutomationLight() {
  const capabilities = [{
    icon: WorkflowIcon,
    text: 'Route leads intelligently'
  }, {
    icon: ZapIcon,
    text: 'Trigger automated workflows'
  }, {
    icon: DatabaseIcon,
    text: 'Sync directly into CRMs'
  }, {
    icon: BrainCircuitIcon,
    text: 'Collect structured information'
  }];
  return <section className="w-full bg-white py-28 md:py-36 relative overflow-hidden" data-id="element-1312">
      {/* Gradient accents */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#F1B530] opacity-5 rounded-full blur-3xl" data-id="element-1313"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D09F2B] opacity-5 rounded-full blur-3xl" data-id="element-1314"></div>

      <div className="max-w-6xl mx-auto px-8 md:px-12 text-center relative z-10" data-id="element-1315">
        <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl lg:text-6xl mb-6 tracking-tight" data-id="element-1316">
          <span className="bg-gradient-to-r from-[#1A1A1A] via-[#F1B530] to-[#1A1A1A] bg-clip-text text-transparent" data-id="element-1317">
            AI Automation Customisation Advanced
          </span>
        </h2>
        <p className="font-['Inter'] font-light text-xl md:text-2xl text-[#6B6B6B] mb-10" data-id="element-1318">
          Automate More Than Calls. Automate Your Entire Frontline.
        </p>

        <p className="font-['Inter'] text-lg text-[#6B6B6B] max-w-4xl mx-auto mb-16 leading-relaxed font-light" data-id="element-1319">
          For businesses handling 500+ calls per month, unlock advanced
          capabilities that transform your AI answering service into a complete
          frontline automation platform.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-1320">
          {capabilities.map((capability, index) => {
          const Icon = capability.icon;
          return <div key={index} className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 border border-[#E5E5E5] hover:border-[#F1B530]/50 transition-all duration-300 shadow-sm hover:shadow-md h-full flex flex-col items-center justify-center min-h-[180px]" data-id="element-1321">
                <Icon className="w-10 h-10 text-[#F1B530] mx-auto mb-5" data-id="element-1322" />
                <p className="font-['Inter'] text-[#1A1A1A] font-light text-center" data-id="element-1323">
                  {capability.text}
                </p>
              </div>;
        })}
        </div>

        <div className="mb-16 relative" data-id="element-1324">
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 border border-[#E5E5E5] max-w-4xl mx-auto shadow-lg" data-id="element-1325">
            <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80" alt="Automation workflow visualization" className="w-full h-64 object-cover rounded-xl opacity-90" data-id="element-1326" />
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-1327">
              <div className="bg-[#F1B530]/10 backdrop-blur-md border border-[#F1B530]/30 rounded-xl px-8 py-4" data-id="element-1328">
                <p className="font-['Inter'] text-[#F1B530] font-semibold text-lg" data-id="element-1329">
                  Complete Workflow Automation
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-10 border border-[#E5E5E5] mb-12 max-w-3xl mx-auto shadow-sm" data-id="element-1330">
          <h3 className="font-['Inter'] font-semibold text-xl mb-6 text-[#1A1A1A]" data-id="element-1331">
            Extended Capabilities Include:
          </h3>
          <ul className="font-['Inter'] text-[#6B6B6B] space-y-3 text-left max-w-2xl mx-auto font-light" data-id="element-1332">
            <li data-id="element-1333">• Support multi-step decision trees</li>
            <li data-id="element-1334">• Extended conversational capabilities</li>
            <li data-id="element-1335">• Custom API integrations</li>
            <li data-id="element-1336">• Advanced data collection and processing</li>
            <li data-id="element-1337">• Bespoke workflow automation</li>
          </ul>
        </div>

        <Button size="lg" data-id="element-1338">Contact Sales</Button>
      </div>
    </section>;
}
function BoltFAQLight() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'How does the AI answering service work?',
    answer: 'Our AI receptionist answers calls 24/7, captures caller information, handles FAQs, and can even book appointments. It integrates seamlessly with your existing systems and can be customized to match your business needs.'
  }, {
    question: 'Can I customize the greeting and responses?',
    answer: 'Absolutely! You can fully customize your company greeting, upload FAQs, set routing rules, and define your brand voice. The AI learns from your business to provide accurate, on-brand responses.'
  }, {
    question: "What happens if the AI can't handle a call?",
    answer: 'The AI can transfer calls to your team with full context when needed. You set the rules for when calls should be escalated, ensuring important matters always reach the right person.'
  }, {
    question: 'How quickly can I get started?',
    answer: "Setup takes less than 5 minutes. Simply sign up, customize your greeting and settings, forward your number, and you're live. We provide step-by-step guidance throughout the process."
  }, {
    question: 'Is there a contract or commitment?',
    answer: 'No long-term contracts required. Start with our 7-day free trial, then choose a monthly plan that fits your needs. You can upgrade, downgrade, or cancel anytime.'
  }];
  return <section className="w-full bg-white py-28 md:py-36 relative overflow-hidden" data-id="element-1339">
      {/* Gradient accents */}
      <div className="absolute top-20 left-20 w-64 h-64 bg-[#F1B530] opacity-5 rounded-full blur-3xl" data-id="element-1340"></div>
      <div className="absolute bottom-40 right-20 w-80 h-80 bg-[#D09F2B] opacity-5 rounded-full blur-3xl" data-id="element-1341"></div>

      <div className="max-w-4xl mx-auto px-8 md:px-12 relative z-10" data-id="element-1342">
        <div className="text-center mb-16" data-id="element-1343">
          <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl mb-6" data-id="element-1344">
            <span className="bg-gradient-to-r from-[#1A1A1A] via-[#F1B530] to-[#1A1A1A] bg-clip-text text-transparent" data-id="element-1345">
              Frequently Asked Questions
            </span>
          </h2>
          <p className="font-['Inter'] text-lg text-[#6B6B6B] font-light" data-id="element-1346">
            Everything you need to know about our AI answering service
          </p>
        </div>

        <div className="space-y-4" data-id="element-1347">
          {faqs.map((faq, index) => <div key={index} className="bg-white/80 backdrop-blur-sm border border-[#E5E5E5] rounded-2xl overflow-hidden transition-all duration-300 hover:border-[#F1B530]/50 shadow-sm hover:shadow-md" data-id="element-1348">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-8 py-6 flex items-center justify-between text-left" data-id="element-1349">
                <span className="font-['Poppins'] font-semibold text-xl text-[#1A1A1A] pr-8" data-id="element-1350">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-[#F1B530] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-1351" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-1352">
                <div className="px-8 pb-6" data-id="element-1353">
                  <p className="font-['Inter'] text-[#6B6B6B] leading-relaxed font-light" data-id="element-1354">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
export function BoltInspiredLightBase() {
  return <div className="w-full min-h-screen bg-[#FAFAFA]" data-id="element-1355">
      <GradientHeroLight data-id="element-1356" />
      <TrustBadgesLight data-id="element-1357" />
      <BoltValuePropositionLight data-id="element-1358" />
      <BoltFeatureShowcaseLight data-id="element-1359" />
      <BoltIndustryBenefitsLight data-id="element-1360" />
      <BoltPricingPlansLight data-id="element-1361" />
      <BoltTestimonialsLight data-id="element-1362" />
      <BoltAddOnsLight data-id="element-1363" />
      <BoltAdvancedAutomationLight data-id="element-1364" />
      <BoltFAQLight data-id="element-1365" />
    </div>;
}